import React, { Component } from "react";

class MaintenancePage extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
      <h1>In maintence.<br />Comming soon :)</h1>
    );
  }
}
export default MaintenancePage;
